export default __webpack_public_path__ + "static/gauge-0e31c49ce35fe44eebb06def9f951f9e.svg";